import {actionTypes} from "../../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: [],
}

export default (state = initialState, action) => {
	switch (action.type) {
        case actionTypes.USER_LOGIN_REQUEST:
            return {
                ...state,
                loading: true,
            }
		case actionTypes.USER_LOGIN_SUCCESS:
			return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.USER_LOGIN_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.USER_LOGIN_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.USER_LOGIN_RESET_ALL:
            return initialState
		default:
			return state;
	}
};
